const POViewReducer = (state = {}, action) => {
    switch (action.type) {
        case "getSearchShipSuccess": {
            return Object.assign({}, state, {
                SearchShip: action.data,
            });
            break;
        }
        case "getSearchShipFailure": {
            return Object.assign({}, state, {
                SearchShip: action.data,
            });
            break;
        }
        case "getShipDetailsSuccess": {
            return Object.assign({}, state, {
                ShipDetails: action.data,
            });
            break;
        }
        case "getShipDetailsFailure": {
            return Object.assign({}, state, {
                ShipDetails: action.data,
            });
            break;
        }
        case "postAddShipSuccess": {
            return Object.assign({}, state, {
                AddShip: action.data,
            });
            break;
        }
        case "postAddShipFailure": {
            return Object.assign({}, state, {
                AddShip: action.data,
            });
            break;
        }
        case "putUpdateShipSuccess": {
            return Object.assign({}, state, {
                UpdateShip: action.data,
            });
            break;
        }
        case "putUpdateShipFailure": {
            return Object.assign({}, state, {
                UpdateShip: action.data,
            });
            break;
        }
        default: {
            return state;
        }
    }

};
export default POViewReducer;
